import { css } from '@lyearn/style';
import { AI_COLORS } from '@/components/LyearnAI/consts';

export const aiMenuIconFill = css`
  fill: ${AI_COLORS.royalBlue};
`;

export const aiMenuClassName = css`
  &:hover {
    background: rgba(247, 231, 253, 0.6);
  }
`;

export const aiMenuText = css`
  background: linear-gradient(
    90deg,
    ${AI_COLORS.royalBlue} 0%,
    ${AI_COLORS.neonPurple} 53.13%,
    ${AI_COLORS.barney} 100%
  );
  background-clip: text;
  text-fill-color: transparent;
`;
